import React from 'react';
import { BookOpen, Check } from 'lucide-react';
export function VolumesSection() {
  return <section className="py-12 px-6 bg-[#13132b]" data-id="element-276">
      <div className="text-center mb-10" data-id="element-277">
        <h2 className="text-3xl font-black text-white mb-2" data-id="element-278">QUÉ INCLUYE</h2>
        <p className="text-yellow-400 font-bold tracking-widest uppercase text-sm" data-id="element-279">
          Volúmenes Principales
        </p>
      </div>

      <div className="space-y-8" data-id="element-280">
        {/* Volumen 1 */}
        <div className="bg-gradient-to-b from-[#e67e22]/20 to-transparent border border-[#e67e22]/30 rounded-2xl p-6 relative overflow-hidden" data-id="element-281">
          <div className="absolute top-0 right-0 bg-[#e67e22] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-282">
            VOL 1
          </div>

          <div className="flex items-center gap-3 mb-6" data-id="element-283">
            <div className="bg-[#e67e22] p-2 rounded-lg" data-id="element-284">
              <BookOpen className="w-6 h-6 text-white" data-id="element-285" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-286">
              Volumen 1 – Primaria
            </h3>
          </div>

          <ul className="space-y-3" data-id="element-287">
            {['Contenidos básicos organizados', 'Actividades listas para usar', 'Ejercicios progresivos', 'Material claro y práctico'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-288">
                <Check className="w-5 h-5 text-[#e67e22] shrink-0" data-id="element-289" />
                <span className="text-gray-300 text-sm" data-id="element-290">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Volumen 2 */}
        <div className="bg-gradient-to-b from-[#c0392b]/20 to-transparent border border-[#c0392b]/30 rounded-2xl p-6 relative overflow-hidden" data-id="element-291">
          <div className="absolute top-0 right-0 bg-[#c0392b] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-292">
            VOL 2
          </div>

          <div className="flex items-center gap-3 mb-6" data-id="element-293">
            <div className="bg-[#c0392b] p-2 rounded-lg" data-id="element-294">
              <BookOpen className="w-6 h-6 text-white" data-id="element-295" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-296">
              Volumen 2 – Secundaria
            </h3>
          </div>

          <ul className="space-y-3" data-id="element-297">
            {['Álgebra y resolución de problemas', 'Ejercicios aplicados', 'Evaluaciones incluidas', 'Material listo para implementar'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-298">
                <Check className="w-5 h-5 text-[#c0392b] shrink-0" data-id="element-299" />
                <span className="text-gray-300 text-sm" data-id="element-300">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center bg-white/5 py-4 rounded-xl border border-white/10" data-id="element-301">
        <p className="font-medium text-yellow-400" data-id="element-302">
          👉 Todo estructurado para que puedas usarlo directamente en clase.
        </p>
      </div>
    </section>;
}